import React from 'react';
export function PainSection() {
  return <section className="bg-gray-900 text-white py-16 md:py-24 px-4" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <h2 className="text-3xl md:text-5xl font-black mb-8 text-center leading-tight" data-id="element-198">
          Si querés vender por internet, dejame hacerte una pregunta honesta…
        </h2>

        <div className="bg-gray-800 rounded-2xl p-8 md:p-12 mb-8" data-id="element-199">
          <p className="text-xl md:text-2xl font-bold mb-6 text-yellow-400" data-id="element-200">
            ¿Te pasa que querés empezar, pero entre Shopify, productos, tienda,
            pagos, pixel, campañas y contenido terminás abrumado y no hacés
            nada?
          </p>

          <div className="space-y-4 text-lg md:text-xl text-gray-300" data-id="element-201">
            <p data-id="element-202">No porque no tengas ganas.</p>
            <p data-id="element-203">No porque no tengas potencial.</p>
            <p className="text-white font-semibold" data-id="element-204">
              Sino porque hay demasiadas cosas mezcladas y nadie te lo explica
              de una forma simple, ordenada y accionable.
            </p>
          </div>
        </div>

        <div className="space-y-6 text-lg md:text-xl" data-id="element-205">
          <p className="font-semibold" data-id="element-206">Querés generar dinero online.</p>
          <p className="font-semibold" data-id="element-207">Querés construir algo propio.</p>
          <p className="font-semibold" data-id="element-208">Querés tener más libertad.</p>

          <p className="text-gray-300 mt-8" data-id="element-209">
            Pero cuando intentás avanzar, te encontrás con esto:
          </p>

          <ul className="space-y-3 text-gray-300 ml-6" data-id="element-210">
            <li data-id="element-211">• no sabés qué producto crear</li>
            <li data-id="element-212">• no sabés cómo montar la tienda</li>
            <li data-id="element-213">• no sabés cómo cobrar</li>
            <li data-id="element-214">• no sabés cómo configurar Meta Ads</li>
            <li data-id="element-215">• no sabés cómo vincular el pixel</li>
            <li data-id="element-216">• no sabés qué campaña hacer</li>
            <li data-id="element-217">
              • no sabés si el problema es técnico, estratégico o de ejecución
            </li>
          </ul>

          <div className="bg-red-900 bg-opacity-30 border-2 border-red-500 rounded-xl p-6 mt-8" data-id="element-218">
            <p className="text-xl md:text-2xl font-bold text-red-300" data-id="element-219">
              Y al final pasa lo peor: seguís consumiendo contenido, pero no
              lanzás nada.
            </p>
          </div>
        </div>
      </div>
    </section>;
}